import PropTypes from 'prop-types';
import React from 'react';

import Link from '../Link';
import * as S from './styled';

const PersonSummary = ({ name, url, subtitle, photo }) => {
  return (
    <S.PersonSummaryContainer itemScope itemType="http://schema.org/Person">
      {photo && (
        <Link href={url}>
          <S.PersonSummaryImage
            itemProp="image"
            src={photo.url}
            alt={photo.altText}
          />
        </Link>
      )}
      <S.PersonSummaryContent>
        {url && (
          <Link href={url}>
            <S.PersonSummaryLink itemProp="name">{name}</S.PersonSummaryLink>
          </Link>
        )}
        <p itemProp="subTitle">{subtitle}</p>
      </S.PersonSummaryContent>
    </S.PersonSummaryContainer>
  );
};

PersonSummary.propTypes = {
  name: PropTypes.string.isRequired,
  url: PropTypes.string,
  subtitle: PropTypes.string.isRequired,
  photo: {
    id: PropTypes.string,
    url: PropTypes.string,
    altText: PropTypes.string,
  },
};

export default PersonSummary;
